import React from 'react';
import fotoUsuario from '../assets/img/user.png';
import user from '../styles/user.module.css';
import useUserActions from '../hooks/useUserActions';
import secureLocalStorage from 'react-secure-storage';
import { useNightMode } from "../hooks/useNightMode";
import { useTheme } from "../context/AppThemeContext";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";



const User = () => {
  const { isNight, toggleNightMode } = useTheme();
  const { handlePasswordChange, handleLogout } = useUserActions();
  const email = secureLocalStorage.getItem("email");
  const navigate = useNavigate();

  return (
    <div className={user.user}>
      <button className={`${user.backButton} backButton`} onClick={() => navigate(-1)}>
        Volver
      </button>
      <div className={user.informacion}>
        <img src={fotoUsuario} alt="Usuario" />
        <h2 className="tituloUser">Bienvenida</h2>
        <h2 className="tituloUser">Correo electrónico: {email?.toString()}</h2>
      </div>
      <div className={user.botones}>
        <button onClick={handlePasswordChange}>Cambiar Contraseña</button>
        <button onClick={handleLogout}>Cerrar Sesión</button>
      </div>
    </div>
  );
};

export default User;